import { ApiProperty } from '@nestjs/swagger'
import { IsNotEmpty, IsString, IsUUID } from 'class-validator'

/**
 * DTO léger pour une classe (id + nom uniquement).
 * Utilisé pour les requêtes batch quand seul le nom est nécessaire.
 */
export class LightClassDto {
  @ApiProperty({
    type: 'string',
    description: 'ID de la classe',
    example: '550e8400-e29b-41d4-a716-446655440000',
  })
  @IsNotEmpty()
  @IsUUID('4')
  id!: string

  @ApiProperty({
    type: 'string',
    description: 'Nom de la classe',
    example: '6e A',
  })
  @IsNotEmpty()
  @IsString()
  name!: string
}
